// extracted by mini-css-extract-plugin
export default {"search_window":"SearchWindow_search_window__f4uqZ","search_window_item":"SearchWindow_search_window_item__WSfQu"};